<div [class]="!isMobile ? 'booble-backdrop-drawer-right' : ''">
  <div class="overflow-modal" [class]="!isMobile ? 'drawer-rtl-in' : ''">
    <div [class]="!isMobile ? 'drawer-content-lg' : ''">
      <div
        [class]="!isMobile ? 'drawer-header padding-left-32' : ''"
        class="row"
      >
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <div class="row gap-22 mobile-row mg-top-32">
              <div
                class="col-md col col-xs-4"
                [ngClass]="{
                  'border-blue': step === 1,
                  'border-grey': step != 1
                }"
              ></div>

              <div
                *ngIf="hasDocumentStep"
                class="col-md col col-xs-4"
                [ngClass]="{
                  'border-blue': step === 2,
                  'border-grey': step != 2
                }"
              ></div>
            </div>

            <div
              [class]="
                isMobile ? 'justify-content-between' : 'justify-content-end'
              "
              class="row d-flex mt-3 mb-4"
            >
              <ng-container *ngIf="isMobile">
                <img
                  (click)="step === 1 ? closeModal() : goBackHandler()"
                  src="assets/icons/arrow-drawer.svg"
                />
              </ng-container>
              <p>Passo {{ step }} de {{ hasDocumentStep ? 2 : 1 }}</p>
            </div>

            <h2 class="title-modal">Receber dinheiro do exterior</h2>
            <p
              class="p-text-grey-scale-dark"
              [class]="isMobile ? '' : 'mg-bottom-24'"
            >
              Selecione ou preencha as informações sobre o seu recebimento.
            </p>
          </div>
        </div>

        <div
          *ngIf="!isMobile"
          class="col-md-1 d-flex justify-content-end mg-top-10"
        >
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div [class]="!isMobile ? 'modal-dialog-scrollable-general' : ''">
        <div [class]="!isMobile ? 'modal-body' : ''" class="h-100">
          <app-finality-selection-inbound
            *ngIf="step === 1"
            [rType]="0"
            [warrenGlobalOnly]="warrenGlobalOnly"
            (finalitySelectedInbound)="finalitySelectedHandler($event)"
          >
          </app-finality-selection-inbound>

          <app-documents-order-inbound
            *ngIf="step === 2"
            (goBack)="goBackHandler()"
            (closeModal)="closeModal()"
            [loading]="loading"
            [finality]="finality"
            class="component"
            (sendFile)="sendFileHandler($event)"
          ></app-documents-order-inbound>
        </div>
      </div>
    </div>
  </div>
</div>
